module.exports = __webpack_public_path__ + "static/media/fall.4ace5796.png";